import { useEffect, useState } from "react";
import Card from "../../components/Card";
import { Product } from "../../models/product";
import { Button, InputNumber, Select, Typography, message } from "antd";
import { AuthService } from "../../services/AuthService";
import Search from "antd/es/input/Search";


const { Text } = Typography;
const StockManagment = () => {

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);

    const [maxQuantity, setMaxQuantity] = useState(0);

    const [stockMove, setStockMove] = useState({
        productId: null,
        quantityToMove: null,
        sourceStoreId: null,
        destinationStoreId: null,

    })

    const [product, setProduct] = useState<Product>({
        id: null,
        productId: null,
        name: null,
        barcode: null,
        productNo: null,
        description: null,
        categoryId: null,
        brandId: null,
        price: null,
        discount: 0,
        discountedPrice: null,
        storeId: null,
        quantity: null,
        storeStocks: null,
        stocks: null
    })

    const [stores, setStores] = useState([]);

    const mapStoreNames = (stocks, storeData) => {
        return stocks.map(stock => {
            // Find the matching store based on storeId
            const matchingStore = storeData.find(store => store.storeId === stock.storeId);
            return {
                ...stock, // Keep all original stock data
                storeName: matchingStore ? matchingStore.storeName : 'Unknown' // Append storeName
            };
        });
    };

    const getProductDetails = async () => {
       
        if (!product?.barcode) {
            messageApi.open({
                type: 'error',
                content: 'Shenoni barkodin per kerkim..',
            });
            return;
        }
        setSearchLoading(true);
        let res = await AuthService.getProductDetails(product?.barcode);
        console.log("getProductDetails", res);
        if (res && res?.barcode) {
            let stores = await getStores();

            const updatedStocks = mapStoreNames(res?.stocks, stores);
            res.stocks = updatedStocks;
            setProduct(res);
            setStockMove({...stockMove, productId: res?.productId})
            // showModal();
        }
        else {
            messageApi.open({
                type: 'error',
                content: 'Nuk u gjet asnje produkt me shifren qe keni shenuar',
            });
            setProduct({ ...product, barcode: null })
        }
        setSearchLoading(false)
    }

    const getStores = async () => {
        // setLoading(true);
        let res = await AuthService.getStores({});
        console.log("get stores", res);
        if (res && res.items && res.items.length > 0) {
            setStores(res.items);
            return res.items
        }
        return [];
        // setLoading(false)
    }

    const getStockMaxQuantity = (id:any) => {
        console.log({max: product?.stocks?.find(el => el.storeId == id)?.quantity, id })
        let maxQuantity =  product?.stocks?.find(el => el.storeId == id)?.quantity;
        setMaxQuantity(maxQuantity)
    }

    const moveStock = async () => {
        const {productId, quantityToMove, sourceStoreId, destinationStoreId} = stockMove;

        if(!productId || !quantityToMove || !sourceStoreId || !destinationStoreId || (sourceStoreId == destinationStoreId)){
            alert("ka gabim");
            return;
        }
        setLoading(true);
        let res = await AuthService.moveStock(stockMove)

        console.log("res", res)
        if(res){
            setLoading(false);
            messageApi.open({
                type: 'success',
                content: res?.message,
            });
        }
    }

    useEffect(()=>{
        if(product?.storeId){
            getStockMaxQuantity(product?.storeId)
        }
    }, [product?.storeId])
    




    return (
        <div className="row">
            {/* <p>{JSON.stringify(product)}</p> */}
            {contextHolder}
            <div className="col-lg-10">
                <Card title="Levizje Interne">
                    <div className="row">

                        <div className="col-6 mt-0">
                            <Text>Shifra e prodhuesit *</Text>
                            <Search value={product?.barcode} onChange={(e) => setProduct({ ...product, barcode: e.target.value })} onSearch={() => getProductDetails()} loading={searchLoading} />
                        </div>
                        <div className="col-12"> </div>
                    
                            <div className="col-6 mt-3">
                                <Text>Pika origjines</Text>
                                <Select
                                    labelInValue
                                    defaultValue={product?.storeId}
                                    style={{ width: "100%" }}
                                    disabled={!product?.productId}
                                    onChange={(e: any) => {
                                        setProduct({ ...product, storeId: e?.value })
                                        // stockAutofillHandler(e?.value);
                                        setStockMove({ ...stockMove, sourceStoreId: e?.value })
                                    }}
                                    options={product?.stocks ? product?.stocks?.map(item => ({
                                        value: item?.storeId,
                                        label: item?.storeName
                                    })) : []}
                                />
                            </div>
                        
                        <div className="col-6 mt-3">
                            <Text>Pika per alokim</Text>
                            <Select
                                labelInValue
                                defaultValue={product?.storeId}
                                style={{ width: "100%" }}
                                disabled={!product?.productId}
                                onChange={(e: any) => {
                                    // setProduct({ ...product, storeId: e?.value })
                                    setStockMove({ ...stockMove, destinationStoreId: e?.value })
                                    // stockAutofillHandler(e?.value);
                                }}
                                options={stores?.filter(el => el.storeId !== product?.storeId).map(item => ({
                                    value: item?.storeId,
                                    label: item?.storeName
                                }))}
                            />
                        </div>

                        <div className="col-lg-6 mt-3">
                            <Text className="d-block">Sasia per alokim</Text>
                            <InputNumber disabled={!stockMove?.sourceStoreId || !stockMove?.destinationStoreId || !stockMove?.productId} min={1} max={maxQuantity} value={stockMove?.quantityToMove} style={{width: "100%"}} className="quantity-input" onChange={(e) => {
                                   setStockMove({ ...stockMove, quantityToMove: e })
                            }}  />

                        </div>
                        <div className="col-12 mt-3">
                                    <div className="d-flex justify-content-end">
                                        <Button loading={loading} disabled={!stockMove?.sourceStoreId || !stockMove?.destinationStoreId || !stockMove?.productId} type="primary" onClick={()=>moveStock()}>Perfundo</Button>
                                    </div>
                                </div>

                    </div>
                </Card>
            </div>
        </div>
    )
}

export default StockManagment;